// alterado - revisado

const mapaFinanceiroNotaList = [
    {
        id: 0, 
        descricao: '0',
        ordem: 10,
    },
    {
        id: 1, 
        descricao: '1',
        ordem: 20,
    },
    {
        id: 2, 
        descricao: '2',
        ordem: 30,
    },
    {
        id: 3, 
        descricao: '3',
        ordem: 40,
    },
    {
        id: 4, 
        descricao: '4',
        ordem: 50,
    },
    {
        id: 5, 
        descricao: '5',
        ordem: 60,
    },
]

export default mapaFinanceiroNotaList